import { Directive } from '@angular/core';
import { IfNotLoggedInDirectiveDef } from '@df/session/customer/if-not-logged-in.directive.def';

/**
 * Use this directive to present element only in user is logged in
 *
 * ```html
 * <div *ifLoggedIn>...</div>
 * ```
 */
@Directive({
    selector: '[ifNotLoggedIn]',
    standalone: true
})
export class IfNotLoggedInDirective extends IfNotLoggedInDirectiveDef {}
